/*eslint-disable */
import Vue from 'vue'
import Simplert from './alert.vue'
var ComponentClass = Vue.extend(Simplert)
var instance = new ComponentClass()
instance.$mount()
const checkp = document.querySelector('body').appendChild(instance.$el)
Vue.prototype.$Simplert = instance
var pingVM = new Vue(instance)



// WEBPACK FOOTER //
// ./src/components/views/Simplert.js